import { Component, OnInit } from '@angular/core';
import { CoreReviewCardRendererBaseComponent } from '../../shared/core-review-card-rendere-base.component';
import { FieldInstance } from '@workflow/class/field.service';
import { EnumerationItem } from '@workflow/class/enum-item.class';

@Component({
  selector: 'cu-card-review-fields',
  templateUrl: './card-review-fields.component.html',
  standalone: false
})
export class CardReviewFieldsComponent extends CoreReviewCardRendererBaseComponent implements OnInit {
  ngOnInit() {}

  public resolveDisplayValue(field: FieldInstance): string {
    const raw = field.data?.valueString ?? field.data?.value;
    if (raw != null && String(raw).trim().length > 0) {
      return String(raw);
    }

    const payloadList = this.extractPayloadEnum(field);
    if (payloadList?.length) {
      const match = payloadList.find((item) => item?.value != null && String(item.value).trim().length > 0);
      if (match?.label) {
        return String(match.label);
      }
      if (match?.value != null) {
        return String(match.value);
      }
      const first = payloadList[0];
      if (first?.label) {
        return String(first.label);
      }
      if (first?.value != null) {
        return String(first.value);
      }
    }

    const items: EnumerationItem[] = field.enum ?? [];
    if (items.length > 0) {
      const match = items.find((item) => item?.value != null && String(item.value).trim().length > 0);
      if (match?.label) {
        return String(match.label);
      }
      if (match?.value != null) {
        return String(match.value);
      }
      const first = items[0];
      if (first?.label) {
        return String(first.label);
      }
      if (first?.value != null) {
        return String(first.value);
      }
    }

    return 'Optional';
  }

  private extractPayloadEnum(field: FieldInstance): Array<{ label?: string; value?: unknown }> | null {
    const payload = field.config?.payload;
    if (!payload) {
      return null;
    }

    const raw = payload['dropdownLists'];
    if (!raw) {
      return null;
    }

    try {
      const parsed = typeof raw === 'string' ? JSON.parse(raw) : raw;
      return Array.isArray(parsed) ? parsed : null;
    } catch {
      return null;
    }
  }
}
